const btnSignUp = {
  text: 'Sign Up'
};

export default btnSignUp;
